cafm.router = {
    lastNavKey: null,
    lastNavArgs: null,
    lastNavEnum: null,
    init: function () {

        this.Router = this.defineRouter();
    },
    defineRouter: function () {

        return kendo.data.Model.define({
            id: 'cafmRouterId',
            init: function (atts) {

                // ensure atts
                if (!atts) atts = {}
                // call the base kendo init method
                kendo.data.Model.fn.init.call(this, atts);

                var me = this;

                function parseFragments(path, fragments, replacements) {

                    var close;
                    var open = path.indexOf('{');
                    if (open > -1) {
                        fragments.push(path.substring(0, open));
                        close = path.indexOf('}');
                        if (close > -1) {
                            close++;
                            var repl = path.substring(open, close);
                            replacements.push(repl);
                        }
                    }
                    else {
                        fragments.push(path);
                        return;
                    }

                    if (path.length <= close) {
                        return;
                    }
                    else {
                        parseFragments(path.substring(close), fragments, replacements)
                    }
                }

                var routes = [];
                $.each(atts.routes, function (name, route) {

                    var fragments = [];
                    var replacements = [];
                    var path = route.path;

                    parseFragments(route.path, fragments, replacements);

                    replacements.forEach(function (rep) {

                        path = path.replace(rep, '[\\w -=]+');
                        path = path.replace(/\//g, '\/');
                    });

                    routes.push({
                        name: name,
                        path: route.path,
                        regExp: new RegExp('^' + path + '$', 'i'),
                        onPreRouteChange: route.onPreRouteChange,
                        handler: route.handler,
                        fragments: fragments,
                        replacements: replacements,
                        noCache: route.noCache,
                        fixedScrollbar: route.fixedScrollbar,
                        noScroll: route.noScroll,
                        documentTitle: route.documentTitle
                    });
                });
                this.routes = routes;

                // bind hashchange event
                $(window).on('hashchange', function (e) {

                    me.process();
                });

                if (this.get('processOnInit')) {

                    this.process();
                }
            },
            process: function () {

                var hash = decodeURIComponent(window.location.hash.substring(1));
                var matchedRoute;
                var arg;

                if (hash) {

                    $.each(this.routes, function (name, route) {

                        if (route.regExp.test(hash)) {

                            if (route.replacements.length) {
                                var params = [];

                                var parseParams = function (frags, i) {

                                    var frag = frags[i];
                                    hash = hash.replace(frag, '');

                                    if (i < (frags.length - 1)) {
                                        var nextFrag = frags[i + 1];
                                        var index = hash.indexOf(nextFrag, '');
                                        var param = hash.substring(0, index);
                                        params.push(param);
                                        hash = hash.replace(param, '');
                                    }
                                    else {
                                        params.push(hash);
                                    }

                                    if (i == (frags.length - 1)) {
                                        return;
                                    }
                                    else {
                                        parseParams(frags, ++i);
                                    }
                                }
                                parseParams(route.fragments, 0);

                                arg = {};
                                $.each(route.replacements, function (i, rep) {

                                    var name = rep.replace(/{|}/g, '');
                                    arg[name] = params[i];
                                });
                            }
                            matchedRoute = route;
                            return false;
                        }
                    });
                }

                if (matchedRoute && isFunc(matchedRoute.handler)) {

                    var me = this;

                    var matchedRouteHandle = function (me, matchedRoute) {

                        if (me.lastNavKey) {

                            me.set('previousRouteInfo', {

                                lastNavKey: me.lastNavKey,
                                lastNavArgs: me.lastNavArgs,
                                lastNavEnum: me.lastNavEnum
                            });
                        }

                        me.lastNavKey = matchedRoute.name;
                        me.lastNavArgs = arg;
                        me.lastNavEnum = cafm.enums.Navigatable[matchedRoute.name];

                        me.fireRouteChanged();
                        me.set('routeChangedHandlers', []);

                        if (me.get('cache') && !matchedRoute.noCache) {
                            me.cacheRouteInfo(matchedRoute);
                        }

                        var centreCol = $('#centreCol');
                        if (matchedRoute.fixedScrollbar && !isMobile) {

                            centreCol.addClass('fixedYScroll');
                        }
                        else if (centreCol.hasClass('fixedYScroll')) {

                            centreCol.removeClass('fixedYScroll');
                        }

                        var hArgs = {
                            router: me
                        };

                        if (!me.suppressNextHandler) {

                            if (arg) {

                                hArgs.args = arg;
                            }

                            matchedRoute.handler(hArgs);

                            var docTitle = matchedRoute.documentTitle;
                            document.title = (docTitle ? (docTitle + " - ") : "") + cafm.res.str.TitleCafmWeb;
                        }
                        else {

                            delete me.suppressNextHandler;
                        }

                        me.set('activeRoute', matchedRoute);
                        
                        if (isFunc(me.onRouteChange)) {

                            me.onRouteChange(me);
                        }

                        if (matchedRoute.noScroll) {

                            centreCol.addClass('noScroll');
                        }
                        else if (centreCol.hasClass('noScroll')) {

                            centreCol.removeClass('noScroll');
                        }
                    }

                    var activeRoute = me.get('activeRoute');
                    var proceed = true;

                    if (activeRoute && isFunc(activeRoute.onPreRouteChange) && !me.get('onPreRouteChangeActivated')) {

                        proceed = activeRoute.onPreRouteChange({

                            routeHandle: function (proceed) {

                                matchedRouteHandle(me, matchedRoute);
                            }
                        });
                    }

                    if (proceed) {
                        matchedRouteHandle(me, matchedRoute);
                    }
                }
                else {

                    if (this.routeKey) {

                        var rName = this.routeKey;
                        var rArgs = this.routeArgs;
                        delete this.routeKey;
                        delete this.routeArgs;
                        this.navigate(rName, rArgs);
                    }
                    else if (!this.cache || !this.restoreCachedRoute({ preventNavigateDefault: true })) {

                        var drk = cafm.nav.defaultRouteKey;
                        var uk = cafm.enums.getEnumKey(cafm.enums.Navigatable, cafm.enums.Navigatable.Undetermined);
                        var d = drk && drk !== uk ? cafm.nav.defaultRouteKey : this.get('default');
                        if (d) {

                            this.navigate(d);
                        }
                    }
                }
            },
            navigate: function (navKey, args, pathName) {

                if (isNum(navKey)) {
                    navKey = cafm.enums.getEnumKey(cafm.enums.Navigatable, navKey);
                }

                var route = cafm.util.find(this.routes, function (r) {
                    return r.name == navKey;
                });

                if (route) {
                    var path = route.path;
                    if (args) {
                        $.each(args, function (i, arg) {

                            path = path.replace('{{0}}'.format(i), arg);
                        });
                    }

                    if (!pathName) {
                        var currentPath = window.location.hash;
                        if (currentPath && currentPath.length > 1) {
                            currentPath = currentPath.substring(1);
                        }
                        else {
                            currentPath = '';
                        }

                        if (currentPath != path) {
                            window.location.hash = '#' + path;
                        }
                        else if (currentPath) {
                            this.process();
                        }
                    }
                    else {

                        window.location = '{0}#{1}'.format(pathName, path);
                    }
                    return true;
                }
                return false;
            },
            navigateDefault: function () {

                var defaultRoute = this.get('default');

                if (isNullOrUndefined(defaultRoute)) {

                    defaultRoute = cafm.nav.defaultRouteKey;
                }

                this.navigate(defaultRoute);
            },
            refresh: function () {

                this.navigate(this.lastNavKey, this.lastNavArgs);
            },
            onRouteChanged: function (h) {
                var rch = this.get('routeChangedHandlers') || [];
                rch.push(h);
            },
            fireRouteChanged: function () {

                var rch = this.get('routeChangedHandlers');

                if (rch) {

                    $.each(rch, function (i, h) {

                        if (isFunc(h)) {
                            h();
                        }
                    });
                }

                cafm.router.enablePreRouteChangedHandler(true);
            },
            getCurrentRouteInfo: function (url) {

                if (url) {

                    return {

                        navUrl: url
                    };
                }
                else {

                    return {
                        navUrl: '{0}{1}'.format(document.location.pathname, document.location.hash),
                        navKey: this.lastNavKey,
                        navEnum: this.lastNavEnum,
                        navArgs: this.lastNavArgs
                    };
                }
            },
            getPreviousRouteInfo: function () {

                return this.get('previousRouteInfo');
            },
            cacheRouteInfo: function () {

                cafm.cache.set(cafm.res.consts.CacheKey_LastRouteInfo, this.getCurrentRouteInfo());
            },
            restorePreviousRoute: function () {
                /// <summary>Restores the users previous route for a module</summary>
                /// <returns type="Boolean">True if there is a previous route and it's restored, false if the default route is restored</returns>

                var prev = this.get('previousRouteInfo');

                if (prev && prev.lastNavKey) {

                    this.navigate(prev.lastNavKey, prev.lastNavArgs);
                    return true;
                }
                else {

                    this.navigateDefault();
                    return false;
                }
            },
            restoreCachedRoute: function (args) {
                /// <summary>Restores the cached route for a module</summary>
                /// <param name="args" type="Object">Args object, optional and can include the preventNavigateDefault boolean option</param>
                /// <returns type="Boolean">True if there is a cached route for the module and it's restored, false if the default route is restored</returns>

                var routeInfo = cafm.cache.get(cafm.res.consts.CacheKey_LastRouteInfo);

                if (routeInfo && (routeInfo.navUrl.startsWith('{0}#'.format(window.location.pathname)) || routeInfo.navUrl.startsWith('{0}/'.format(window.location.pathname)))) {

                    this.navigate(routeInfo.navKey, routeInfo.navArgs);
                    return true;
                }
                else if (!args || !args.preventNavigateDefault) {

                    this.navigateDefault();
                    return false;
                }
            },
            addRouteToHistory: function (props) {

                nav.addToHistory(props, this);
            }
        })
    },
    removeCachedRouteInfo: function () {

        cafm.cache.remove(cafm.res.consts.CacheKey_LastRouteInfo);
    },
    setDefaultRouteKey: function (routeKey) {
        
        cafm.nav.defaultRouteKey = routeKey;
    },
    loadRoute: function (url) {

        cafm.cache.set(cafm.res.consts.CacheKey_LastRouteInfo, {
            navUrl: url
        });

        cafm.url.set(url);
    },
    enablePreRouteChangedHandler: function (value) {
        
        if (cafm.nav.router) {

            cafm.nav.router.set('onPreRouteChangeActivated', !value);
        }
    }
}